/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const ROUTES = {
  ACCOUNT_MAIN: '/main-account',
  ACCOUNT_ADDRESSES: '/addresses',
  ACCOUNT_ADDRESS_DETAIL: '/address-detail',
  ACCOUNT_FAMILY_FRIENDS: '/family-friends',
  ACCOUNT_EMAIL_ACTIVATION: '/email-activation',
  ACCOUNT_CURRENCY: '/currency',
  ACCOUNT_THEME: '/theme',
  ACCOUNT_VERIFY_PHONE: '/verify-phone',
  ACCOUNT_VERIFY_EMAIL: '/verify-email',
  ACCOUNT_UPDATE_PHONE: '/update-phone',
  ACCOUNT_UPDATE_EMAIL: '/update-email',
  ACCOUNT_LANGUAGES: '/languages',
  ACCOUNT_LOGIN: '/login',
  ACCOUNT_SIGN_UP: '/sign-up',
  ACCOUNT_SIGN_UP_FORM: '/sign-up-form',
  ACCOUNT_FORGOT_PASSWORD: '/forgot-password',
  ACCOUNT_MANAGE_ACCOUNT: '/manage-account',
  ACCOUNT_MANAGE_TRIP: '/manage-trip',
  ACCOUNT_FAVOURITES: '/favourites',
  ACCOUNT_FAVOURITE_LOB: '/favourite-by-lob',
  ACCOUNT_PERSONAL_DETAILS: '/personal-details',
  ACCOUNT_FAMILY_FRIENDS_DETAIL: '/family-friends-detail',
  ACCOUNT_TRAVEL_DETAILS: '/travel-details',
  ACCOUNT_SUPPORT_FEEDBACK: '/support-and-feedback',
  ACCOUNT_MY_CASES: '/my-cases',
  ACCOUNT_ABOUT_US: '/about-us',
  ACCOUNT_SECURITY: '/security',
  ACCOUNT_PASSKEYS: '/passkey',
  ACCOUNT_RECENT_ACTIVITIES: '/recent-activities',
  ACCOUNT_RECENT_SECURITY_ACTIVITY_DETAIL: '/recent-security-activity-detail',
  ACCOUNT_PAYMENTS: '/payments',
  ACCOUNT_SAVED_CARD: '/saved-card',
  ACCOUNT_CARD_DETAILS: '/card-details',
  ACCOUNT_CHANGE_PASSWORD: '/change-password',
  ACCOUNT_CREATE_NEW_PASSWORD: '/create-new-password',
  ACCOUNT_PASSWORD_UPDATED: '/password-updated',
  ACCOUNT_BOARDING_PASS: '/boarding-pass',
  ACCOUNT_FLIGHT_STATUS: '/flight-status',
  ACCOUNT_CHECK_IN: '/check-in',
  ACCOUNT_ASEAN_PASS: '/asean-pass',
  ACCOUNT_CREDIT_ACCOUNT: '/credit-account',
  ACCOUNT_TERMS_AND_CONDITIONS: '/terms-and-conditions',
  ACCOUNT_SETTINGS: '/settings',
  ACCOUNT_DEV_SETTINGS: '/dev-settings',
  ACCOUNT_NOTIFICATION_PREFERENCES: '/notification-preferences',
  ACCOUNT_NOTIFICATION_CHANNEL_DETAIL: '/notification-channel-detail',
  ACCOUNT_NOTIFICATION_CATEGORY_DETAIL: '/notification-category-detail',
  ACCOUNT_PARTNERS: '/partners',
  ACCOUNT_TWO_FA: '/two-fa',
  ACCOUNT_DELETE_ACCOUNT: '/delete-account',
  ACCOUNT_DELETION_STATUS: '/account-deletion-status',
  ACCOUNT_DELETE_CREDIT_BALANCE: '/delete-account-credit-balance',
  ACCOUNT_AUTH_WEBVIEW: '/account/authenticated-webview',
};

export const ACCOUNT_ROOT_SEGMENTS: ReadonlySet<string> = new Set(
  Object.values(ROUTES).map((path) => path.split('/').filter(Boolean)[0]),
);

/** Tells the create-new-password screen the user is resetting, not logged in. */
export const FORGOT_PASSWORD_FLOW = 'forgot-password';
